import { LAYOUT_ALGORITHM } from "./layoutAlgorithm";
export default {
    [LAYOUT_ALGORITHM.HIERARCHIC]: "Иерархический",
    [LAYOUT_ALGORITHM.ORGANIC]: "Органический",
    [LAYOUT_ALGORITHM.ORTHOGONAL]: "Ортогональный",
    [LAYOUT_ALGORITHM.CIRCULAR]: "Круговой",
    [LAYOUT_ALGORITHM.TREE]: "Дерево"
};
